module.exports = __webpack_public_path__ + "static/media/Sagheer.332ecdd1.jpeg";